import { render, staticRenderFns } from "./ProcessPolicy.vue?vue&type=template&id=1391800c&scoped=true&"
import script from "./ProcessPolicy.vue?vue&type=script&lang=js&"
export * from "./ProcessPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1391800c",
  null
  
)

export default component.exports